import type {AgentMergeEvaluationScope} from '@github-ui/dotcom-schema/types/copilot_sessions/v1/agent_merge'
import type {QueryClient} from '@github-ui/react-query'

import {
  evaluationConfigurationFence,
  mergeEvaluationConfigurationFences,
  type AgentMergeConfigurationResponse,
  type AgentMergeEvaluationConfigurationFence,
} from '../page-data/payloads/agent-merge'

const fenceKeyPrefix = ['agentMergeEvaluationConfigurationFence'] as const

function fenceQueryKey(scope: AgentMergeEvaluationScope) {
  return [
    ...fenceKeyPrefix,
    scope.scope?.namespace,
    scope.scope?.repositoryId.toString(),
    scope.scope?.pullRequestNumber.toString(),
    scope.scope?.pullRequestId.toString(),
    scope.repositoryOwnerId,
    scope.repositoryOwnerType,
  ] as const
}

export function readEvaluationConfigurationFence(client: QueryClient, scope: AgentMergeEvaluationScope | undefined) {
  return scope ? client.getQueryData<AgentMergeEvaluationConfigurationFence>(fenceQueryKey(scope)) : undefined
}

export function rememberEvaluationConfigurationFence(
  client: QueryClient,
  configuration: AgentMergeConfigurationResponse,
) {
  const fence = evaluationConfigurationFence(configuration)
  if (!fence) return
  // Head-keyed display data can expire. The document still needs the record-order fence.
  client.setQueryDefaults(fenceKeyPrefix, {gcTime: Infinity})
  client.setQueryData<AgentMergeEvaluationConfigurationFence>(fenceQueryKey(fence.scope), previous =>
    mergeEvaluationConfigurationFences(previous, fence),
  )
}
